export default {"src":"/_next/static/media/reebelo-text.3012bad1.svg","height":24,"width":100,"blurWidth":0,"blurHeight":0};